import _ from "lodash";
import {byId} from "@/helper/application/characteristic/Provider";
import * as CharacteristicTag from "@/helper/characteristic/Tag";
import {characteristicMultiple} from "@/helper/application/Populate";
import {DateTime} from "luxon";

export function populate (careers, meta)
{
	let populatedCareers = [];

	_.forEach(careers || [], item =>
	{
		item.careerType = byId(item.careerType, meta.careerType);

		const isJob = CharacteristicTag.hasTag(item.careerType, CharacteristicTag.CAREER_JOB);
		const isEducation = CharacteristicTag.hasTag(item.careerType, CharacteristicTag.CAREER_EDUCATION);

		if (isJob)
		{
			item.industrialSectors = characteristicMultiple(item.industrialSectors, meta, meta.industrialSector, true);
			item.functions = characteristicMultiple(item.functions, meta, meta.function, meta.functionType, true);
			item.careerLevel = byId(item.careerLevel, meta.careerLevel);
		}

		if (isEducation)
		{
			item.schoolType = byId(item.schoolType, meta.schoolType);
			item.schoolLocation = characteristicMultiple(item.schoolLocation, meta, meta.geo, meta.geoType, true);

			if (item.appraiserAuthority)
			{
				item.appraiserAuthority = characteristicMultiple(
					item.appraiserAuthority,
					meta,
					meta.educationAppraiserAuthority,
					meta.educationAppraiserAuthorityType,
					true
				);
			}

			if (item.educationCompletion)
			{
				item.educationCompletion = byId(item.educationCompletion, meta.educationCompletion);
			}

			if (item.educationCompletionType)
			{
				item.educationCompletionType = byId(item.educationCompletionType, meta.educationCompletionTypeItems);
			}

			if (item.furtherInstitutionType)
			{
				item.furtherInstitutionType = byId(item.furtherInstitutionType, meta.educationFurtherInstitutionType);
			}

			if (item.workPermission)
			{
				item.workPermission = byId(item.workPermission, meta.educationWorkPermission);
			}

			if (item.expertProfession)
			{
				item.expertProfession = byId(item.expertProfession, meta.educationExpertProfession);
			}

			if (item.scopeCountries)
			{
				item.scopeCountries = _.map(item.scopeCountries, countryId => byId(countryId, meta.country));
			}

			if (item.validityDate)
			{
				const dateTime = DateTime.fromISO(item.validityDate);

				item.validityDate = {
					day: dateTime.day,
					month: dateTime.month,
					year: dateTime.year
				};
			}
		}

		item.valid = true; // always valid when populating

		populatedCareers.push(item);
	});

	return populatedCareers;
}
